










































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import Pdf from "@/components/Pdf.vue";
import Footer from "@/components/Footer.vue";
import { BIcon, BIconBoxArrowRight, BPopover } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
@Component({
  components: {
    Header,
    Menu,
    Video,
    Pdf,
    Footer,
    BIcon,
    BPopover,
    BIconBoxArrowRight,
    NextPrevBtn,
  },
})
export default class PosterFundamental extends Vue {
  protected pdfPosterKey = [
    {
      PdfLink: "/pdf_poster/6PointKey.pdf",
      PdfDownload: "Les 6 points clés d'une affiche",
      TxtPdf: "Les 6 points clés d'une affiche",
    },
    {
      PdfLink: "/pdf_poster/ExamplePoster.pdf",
      PdfDownload: "Les éléments de composition d’une affiche",
      TxtPdf: "Les éléments de composition d’une affiche",
    },
    {
      PdfLink: "/pdf_poster/MITACS.pdf",
      PdfDownload: "MITACS – Créer une affiche",
      TxtPdf: "MITACS – Créer une affiche",
    },
    {
      PdfLink: "/pdf_poster/CNRS.pdf",
      PdfDownload: "CNRS – Le poster",
      TxtPdf: "CNRS – Le poster",
    },
  ];
  protected nxtprevPosterFundamental = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail4.png",
    PrevLink: "",
    NextLink: "/Affiche/Astuces",
  };
}
